var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({staticClass:"btn"},'el-button',_vm.$attrs.props,false),[_vm._v("\n  "+_vm._s(_vm.$attrs.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }